/**
 * Title-case per la sola visualizzazione: il dato BE resta com'è (spesso UPPERCASE, es.
 * "QUADRILOCALE COMFORT 1 T"), ma il legacy lo mostra "Quadrilocale Comfort 1 T". Abbassa tutto e
 * rialza la prima lettera di ogni parola (lettere unicode). Numeri/sigle di una lettera restano.
 */
export function toTitleCase(value: string): string {
  return value.toLowerCase().replace(/\p{L}[\p{L}']*/gu, (word) => word.charAt(0).toUpperCase() + word.slice(1));
}
